module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("The Coming American")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("Bring me men to match my mountains,")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("Bring me men to match my plains.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("Men to chart a starry empire,")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_vm._v("Men to make celestial claims.…")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("—Samuel Walter Foss, at the base of the ramp leading to the USAFA cadet area from 1958–2003")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Book_Title"
  }, [_c('span', [_vm._v("The Cadet")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3511a36c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0009.vue
// module id = 84
// module chunks = 0